import { render, staticRenderFns } from "./iconChat.vue?vue&type=template&id=ee9f5688&scoped=true&"
import script from "./iconChat.vue?vue&type=script&lang=js&"
export * from "./iconChat.vue?vue&type=script&lang=js&"
import style0 from "./iconChat.vue?vue&type=style&index=0&id=ee9f5688&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee9f5688",
  null
  
)

export default component.exports